import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Getrequestcall } from "../../request/Getrequest";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Icon,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Skeleton,
  Snackbar,
  Stack,
  Typography
} from "@mui/material";
import {
  FETCH_TICKETS,
  FETCH_TICKETS_SHARED_WITH_SUPERVISOR,
  FETCH_USERS_TRADES,
  GET_USER_CONTACT_STATUS_NAME,
  GET_USER_CONTACTS,
  GETUSERINFO,
  INVITEFRIENDSBYEMAIL,
  SAVECONTACTEVENT,
  SEND_SMS_TO_USER_PHONE
} from "../../constant/Apipath";
import { BIBlack, BIBlue, BIRed } from "../../assets/helpers";
import { Email, QrCode } from "@mui/icons-material";
import CallIcon from "@mui/icons-material/Call";
import moment from "moment";
import Loader from "../../common/Loader";
import { English } from "../../constant/EnglishFallback";
import InfoIcon from "@mui/icons-material/Info";
import AboutSekeleton from "./AboutSkeleton";
import ProfileHeaderSkeleton from "./ProfileHeaderSkeleton";
import Editabout from "./Editabout";
import { setLogindata, setShowalert } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import PictureViewer from "../common/PictureViewer";
import Grid from "@mui/material/Grid";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import HomeIcon from "@mui/icons-material/Home";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Editprofile from "./EditProfile";
import { Postrequestcall } from "../../request/Postrequest";
import ReferralModal from "../common/ReferralModal";
import EditTrade from "./EditTrade";
import Experience from "./Experience";
import Education from "./Education";
import Products from "./Products";
import { getFormattedAddress } from "../common/GetFormattedAddress";
import VerifyEmailModal from "./VerifyEmailModal";
import VerifyPhoneModal from "./VerifyPhoneModal";
import MemberList from "../common/MemberList";
import PromptModal from "../common/PromptModal";
import User_Default_Pic from "../../assets/images/avtar_placeholder.jpeg";
import AddContact from "../common/AddContact";
import ErrorIcon from "@mui/icons-material/Error";
import GroupIcon from "@mui/icons-material/Group";
import { createChatGroupAndNavigate } from "../../common/Helper";

export default function NewProfile() {
  // 1. USE HOOKS
  const { userId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // 2. Get the data from redux
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const {
    TEXT_CANCEL_REQUEST = English?.Profile?.TEXT_CANCEL_REQUEST,
    TEXT_ALERT_CANCEL_REQUEST = English?.Profile?.TEXT_ALERT_CANCEL_REQUEST,
    TEXT_DELETE_CONTACT_CONF_TITLE = English?.Profile?.TEXT_DELETE_CONTACT_CONF_TITLE,
    TEXT_DESC_CONFIRMATION = English?.Profile?.TEXT_DESC_CONFIRMATION,
    TEXT_EMAIL_NEED_TO_VERIFIED = English?.Profile?.TEXT_EMAIL_NEED_TO_VERIFIED,
    TEXT_PHONE_NEED_TO_VERIFIED = English?.Profile?.TEXT_PHONE_NEED_TO_VERIFIED,
    TEXT_CONNECT_REQUEST = English?.Profile?.TEXT_CONNECT_REQUEST,
    TEXT_REQUESTED_CONNECT_WITH_YOU = English?.Profile?.TEXT_REQUESTED_CONNECT_WITH_YOU,
    TEXT_RIDE_SHARE_DESC = English?.Profile?.TEXT_RIDE_SHARE_DESC,
    BUTTON_DELETE = English?.Profile?.BUTTON_DELETE,
    TEXT_PRIMARY = English?.Profile?.TEXT_PRIMARY,
    TEXT_WORK = English?.Profile?.TEXT_WORK,
    TEXT_OTHER = English?.Profile?.TEXT_OTHER,
    TEXT_HOME = English?.Profile?.TEXT_HOME,
    TEXT_MOBILE = English?.Profile?.TEXT_MOBILE,
    BUTTON_MODAL_DELETE_YES = English?.Profile?.BUTTON_MODAL_DELETE_YES
  } = multiLanguageData?.Profile || {};

  const {
    TEXT_MASSAGE = English.BuilderNetwork.TEXT_MASSAGE,
    TEXT_COPY_LINK = English.BuilderNetwork.TEXT_COPY_LINK
  } = multiLanguageData?.BuilderNetwork || {};

  const {
    TEXT_REFER_SOMEONE_TO_BUILDID = English?.Profile?.TEXT_REFER_SOMEONE_TO_BUILDID,
    TEXT_BUILDER_NETWORK = English?.Profile?.TEXT_BUILDER_NETWORK,
    TEXT_LOOK_FOR_PEOPPLE = English?.Profile?.TEXT_LOOK_FOR_PEOPPLE,
    TEXT_NO_CONTACT_PLACEHOLDER = English?.Profile?.TEXT_NO_CONTACT_PLACEHOLDER,
    TEXT_SEE_ALL = English?.Profile?.TEXT_SEE_ALL,
    TEXT_NO_MAIN_TRADE = English?.Profile?.TEXT_NO_MAIN_TRADE,
    TEXT_PROFILE_PICTURE = English?.Profile?.TEXT_PROFILE_PICTURE
  } = multiLanguageData?.Profile || {};

  // 3. Declaration of states
  const userInformation = loginData?.userInformation;
  const isSelfProfile = userInformation?.UserId == userId ? true : false;

  const [userData, setuserData] = useState([]);
  const [userAboutData, setUserAboutData] = useState([]);
  const [showEditAbout, setShowEditAbout] = useState(false);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [showProfile, setShowprofile] = useState(false);
  const [contactStatusId, setContactStatusId] = useState(0);
  const [membersModalOpen, setMembersModalOpen] = useState(false);
  const [userTrade, setUserTrade] = useState([]);
  const [verifyPhoneObj, setVerifyPhoneObj] = useState([
    {
      verifyPhoneNo: "",
      verifyPhoneId: "",
      verifyCountryCode: ""
    }
  ]);
  const [showBtnLoader, setShowBtnLoader] = useState(false);

  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [showTrade, setShowTrade] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [isContactInList, setIsContactInList] = useState(false);

  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);
  const [cancelConfirmModalOpen, setCancelConfirmModalOpen] = useState(false);
  const [verifyEmailModalOpen, setVerifyEmailModalOpen] = useState(false);
  const [verifyPhoneModalOpen, setVerifyPhoneModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [closeTradeFrom, setCloseTradeFrom] = useState(false);

  const [editFrom, setEditFrom] = useState("");
  const [userMemberList, setUserMemberList] = useState([]);

  const [Initialisation, setInitialisation] = useState(true);
  const [miniLoader, setMiniLoader] = useState({
    profileLoader: true,
    aboutLoader: true,
    experienceLoader: true,
    certificationLoader: true,
    productLoader: true
  });
  const [memberListLoading, setMemberListLoading] = useState(true);
  const [editedTab, setEditedTab] = useState("Profile");
  const [contactData, setContactData] = useState([]);
  const [newContactModalOpen, setNewContactModalOpen] = useState(false);
  const [shouldCall, setShouldCall] = useState(false);
  const [ticketLoading, setTicketLoading] = useState(true);
  const [resetTradeLoadingFn, setResetTradeLoadingFn] = useState(null);
  const [userTicketData, setUserTicketData] = useState([]);

  const [ticketStatus, setTicketStatus] = useState("");

  useEffect(() => {
    if (location.state?.openTradeModal) {
      setShowTrade(true);
      handleTradeModal("profile");
    }
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 500);
    }
  }, [location.state]);

  useEffect(() => {
    setInitialisation(true);
    const callInitialStage = async () => {
      setMiniLoader({
        profileLoader: true,
        aboutLoader: true,
        experienceLoader: true,
        certificationLoader: true,
        productLoader: true
      });
      await Promise.all([
        fetchUserData(),
        fetchUserTradeData(),
        setUpUserMemberListData(),
        setUpMemberListStatus(),
        !isSelfProfile ? fetchTicketsSharedWithSupervisor() : null,
        getUserContact(),
        isSelfProfile === false ? fetchUserTicket() : null
      ]);
    };
    callInitialStage();
  }, [userId]);

  const fetchTicketsSharedWithSupervisor = async () => {
    try {
      const getObj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: Number(loginData?.userInformation?.UserId),
        IncludeRecordNr: true,
        SearchList: [
          {
            userId: Number(userId),
            supervisorId: Number(loginData?.userInformation?.UserId)
          }
        ],
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ]
      };
      const getResponse = await Postrequestcall(
        FETCH_TICKETS_SHARED_WITH_SUPERVISOR,
        getObj,
        loginData?.accessToken
      );
      if (getResponse?.status === 201 || getResponse?.status === 200) {
        const getUserinfo = getResponse?.data?.data[0] || {};
        setTicketStatus(getUserinfo?.status || "");
      }
    } catch (error) {
      console.log("fetchTicketsSharedWithSupervisor Error:", error);
    }
  };

  // 5. API calling Function

  const fetchUserData = async (status) => {
    try {
      if (status === 1) {
        setMiniLoader({
          ...miniLoader,
          aboutLoader: true
        });
      } else {
        setMiniLoader({
          ...miniLoader,
          profileLoader: true
        });
      }
      const res = await Getrequestcall(`${GETUSERINFO}/${userId}`, loginData?.accessToken);

      if (res?.status === 200) {
        const data = res?.data?.data;
        setuserData(data);

        // setting About Section Data
        let getContactinfo = [];
        let newEmailArray = [];
        let newPhoneArray = [];
        let newAddress = [];
        let newArray = [];
        if (isSelfProfile) {
          if (
            data?.pictureUrl !== loginData?.pictureUrl ||
            data?.firstName !== loginData?.userInformation?.FirstName ||
            data?.lastName !== loginData?.userInformation?.LastName ||
            data?.tradeName !== loginData?.userInformation?.TradeName
          ) {
            dispatch(
              setLogindata({
                ...loginData,
                pictureUrl: data?.pictureUrl,
                userInformation: {
                  ...userInformation,
                  FirstName: data?.firstName,
                  LastName: data?.lastName,
                  TradeName: data?.tradeName
                }
              })
            );
          }
        }

        // Email filtering logic
        if (isSelfProfile) {
          // For own profile: show all emails (verified + unverified, public + private)
          newEmailArray = data?.emails || [];
        } else {
          // For other's profile: only show emails that are both verified AND public
          newEmailArray =
            data?.emails?.filter((email) => {
              return email.verified === true && email.isPublicEmail === true;
            }) || [];
        }

        // Phone filtering logic
        if (isSelfProfile) {
          // For own profile: show all phones (verified + unverified, public + private)
          newPhoneArray = data?.phones || [];
        } else {
          // For other's profile: only show phones that are both verified AND public
          newPhoneArray =
            data?.phones?.filter((phone) => {
              return phone.verified === true && phone.isPublicPhone === true;
            }) || [];
        }

        if (newEmailArray?.length !== 0 || data?.userEmail) {
          let getEmails = [];

          if (data?.userEmail) {
            // Always add the primary email first
            if (isSelfProfile) {
              // For own profile: always show primary email regardless of verification/public status
              getEmails.push({
                icon: <Email sx={{ color: BIBlue }} />,
                textOne: data?.userEmail,
                textTwo: TEXT_PRIMARY,
                verified: data?.verified,
                isDefaultEmail: true,
                isPublicEmail: true,
                isPrivateEmail: false
              });
            } else {
              // For other's profile: find primary email in the emails array to check its status
              const primaryEmailData = data?.emails?.find(
                (email) => email.email === data?.userEmail
              );
              if (
                primaryEmailData &&
                primaryEmailData.verified === true &&
                primaryEmailData.isPublicEmail === true
              ) {
                // Show primary email if it's verified and public
                getEmails.push({
                  icon: <Email sx={{ color: BIBlue }} />,
                  textOne: data?.userEmail,
                  textTwo: TEXT_PRIMARY,
                  verified: primaryEmailData.verified,
                  isDefaultEmail: true,
                  isPublicEmail: primaryEmailData.isPublicEmail,
                  isPrivateEmail: primaryEmailData.isPrivateEmail
                });
              }
            }
          }

          // Add other emails
          const otherEmails = newEmailArray
            .map((email, index) => {
              // Skip the default email if it's already added above
              if (email?.email === data?.userEmail) {
                return null;
              }
              return {
                icon: !newEmailArray.includes("Email") ? (
                  <Icon />
                ) : (
                  <Email sx={{ color: BIBlue }} />
                ),
                textOne: email?.email,
                textTwo:
                  email?.emailType.charAt(0) === "H" || email?.emailType.charAt(0) === "P"
                    ? TEXT_HOME
                    : email?.emailType.charAt(0) === "M"
                      ? TEXT_MOBILE
                      : email?.emailType.charAt(0) === "W"
                        ? TEXT_WORK
                        : email?.emailType.charAt(0) === "O"
                          ? TEXT_OTHER
                          : "",
                verified: email?.verified,
                isPrivateEmail: email?.isPrivateEmail,
                isPublicEmail: email?.isPublicEmail
              };
            })
            .filter((email) => email !== null);

          getEmails = [...getEmails, ...otherEmails];
          getContactinfo = [...getContactinfo, ...getEmails];
        }

        if (newPhoneArray?.length !== 0) {
          let getPhones = newPhoneArray?.map((phone, index) => {
            return {
              icon: index === 0 ? <CallIcon sx={{ color: BIBlue }} /> : <Icon />,
              textOne: phone?.countryCode + " " + phone?.phoneNo,
              textTwo:
                phone?.phoneType.charAt(0) === "H"
                  ? TEXT_HOME
                  : phone?.phoneType.charAt(0) === "M"
                    ? TEXT_MOBILE
                    : phone?.phoneType.charAt(0) === "W"
                      ? TEXT_WORK
                      : phone?.phoneType.charAt(0) === "O"
                        ? TEXT_OTHER
                        : "",
              verified: phone?.verified,
              isPublicPhone: phone?.isPublicPhone,
              isPrivatePhone: phone?.isPrivatePhone
            };
          });

          getContactinfo = [...getContactinfo, ...getPhones];
        }

        // Only add address if it's self profile
        const userAddress = isSelfProfile ? res?.data?.data?.userAddresses || {} : {};

        let { city, country, province, postalCode, address, address1 } = userAddress
          ? userAddress
          : {};

        city =
          city !== "" && city
            ? city.replace(
                /\w*/g,
                (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
              )
            : "";
        country =
          country !== "" && country
            ? country.replace(
                /\w*/g,
                (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
              )
            : "";

        const uAddress = getFormattedAddress(
          address ?? "",
          address1 ?? "",
          city ?? "",
          province ?? "",
          country ?? "",
          postalCode ?? "",
          3
        );
        if (uAddress !== "") {
          getContactinfo = [
            ...getContactinfo,
            {
              icon: <HomeIcon sx={{ color: BIBlue }} />,
              textOne: uAddress,
              textTwo: "",
              verified: true,
              address: true
            }
          ];
          newArray?.push({
            type: "Address",
            value: uAddress
          });
        } else {
          // If user does not have address
          if (isSelfProfile === true) {
            getContactinfo = [
              ...getContactinfo,
              {
                icon: <HomeIcon sx={{ color: BIBlue }} />,
                textOne: TEXT_RIDE_SHARE_DESC,
                textTwo: "",
                verified: false,
                address: false
              }
            ];
          }
        }
        if (uAddress !== "") {
          newArray?.push({
            type: "Address",
            value: uAddress
          });
        }

        setUserAboutData(getContactinfo);
      } else {
        console.warn("UnExpected Status From Server ");
      }
    } catch (error) {
      console.error("getData-> Error When Getting Data: ", error);
    } finally {
      setInitialisation(false);
      setMiniLoader({
        ...miniLoader,
        aboutLoader: false,
        profileLoader: false
      });
    }
  };

  const fetchUserTradeData = async () => {
    try {
      const userTradeObj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: false,
        SearchList: [{ UserId: userId }]
      };

      let tradeRes = await Postrequestcall(
        FETCH_USERS_TRADES,
        userTradeObj,
        loginData?.accessToken
      );

      if (tradeRes?.status === 200) {
        const userTradeRes2 = tradeRes?.data?.data
          .sort(
            (a, b) =>
              a.tradeType?.toLowerCase().localeCompare(b.tradeType?.toLowerCase()) ||
              a.tradeName?.trim().toLowerCase().localeCompare(b.tradeName?.trim().toLowerCase())
          )
          .map((trade) => {
            trade.tradeType = trade.tradeType.toLowerCase();
            return trade;
          });

        setUserTrade(userTradeRes2);
      } else {
        console.warn("UnExpected Status From Server ");
      }
    } catch (error) {
      console.error("fetchUserTradeData-> Error When Trying To Get User Trade Data: ", error);
    } finally {
    }
  };

  const getUserContact = async () => {
    try {
      let contactRes = await Getrequestcall(
        `${GET_USER_CONTACTS}/${userId}/1/6`,
        loginData?.accessToken
      );
      if (contactRes?.status === 200) {
        setContactData(contactRes?.data);
      } else {
        console.warn("UnExpected Status From Server ");
      }
    } catch (error) {
      console.error("getUserContact-> Error When Trying To Get User Contact Data: ", error);
    } finally {
      if (shouldCall === true) {
        setMiniLoader({
          ...miniLoader,
          builderLoader: false
        });
        setShouldCall(false);
      }
    }
  };

  const fetchUserTicket = async () => {
    setTicketLoading(true);
    let allTicketsArray = [];
    try {
      const getObj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        FullSearch: "",
        SearchList: [{ createdBy: Number(userId) }],
        SortList: [{ FieldName: "Expiry", Direction: "DESC" }]
      };
      let getUserTickets = await Postrequestcall(FETCH_TICKETS, getObj, loginData?.accessToken);
      if (getUserTickets?.status === 201) {
        if (getUserTickets?.data?.status === true || getUserTickets.status === 200) {
          const ticketWithSelection = getUserTickets?.data?.data.map((item) => ({
            ...item,
            isSelected: false
          }));

          const validTicket = ticketWithSelection.filter((value) => {
            const current = moment().format("YYYY-MM-DDThh:mm:ss");
            if (value.expiry >= current || value.expiry === "" || value?.expiry === null)
              return true;
            return false;
          });
          const expiredTicket = ticketWithSelection.filter((value) => {
            const current = moment().format("YYYY-MM-DDTHH:mm:ss");
            return value.expiry && value.expiry <= current;
          });
          allTicketsArray = [
            ...validTicket.sort((a, b) => {
              let dateA = new Date(a.issuedOn),
                dateB = new Date(b.issuedOn);
              return dateB - dateA;
            }),
            ...expiredTicket.sort((a, b) => {
              let dateA = new Date(a.issuedOn),
                dateB = new Date(b.issuedOn);
              return dateB - dateA;
            })
          ];
          // }
          setUserTicketData(allTicketsArray);
        } else if (getUserTickets.status === 401) {
          setUserTicketData([]);
        }
      }
    } catch (error) {
      console.log("fetchUserTicket-> Error When Fetching Tickets: ", error);
      setTicketLoading(false);
    } finally {
      setTicketLoading(false);
    }
  };

  const setUpUserMemberListData = async (isFlag) => {
    if (isSelfProfile === false) {
      if (isFlag === 1) {
        setUpMemberListStatus();
      }
      // Also get contact status for the main user (userId) if needed
      try {
        const contactStatusRes = await Getrequestcall(
          `${GET_USER_CONTACT_STATUS_NAME}/${loginData?.userInformation?.UserId}/${userId}`,
          loginData?.accessToken
        );

        const contactStatus = contactStatusRes?.data?.data;
        if (contactStatus === "Yes") {
          setContactStatusId(1);
        } else if (contactStatus === "No") {
          setContactStatusId(2);
        } else if (contactStatus === "Request Sent") {
          setContactStatusId(3);
        } else if (contactStatus === "Awaiting response") {
          setContactStatusId(4);
        } else if (contactStatus === "Deleted") {
          setContactStatusId(2);
        } else if (contactStatus === "Rejected") {
          setContactStatusId(2);
        } else if (contactStatus === "me") {
          setContactStatusId(5);
          setIsContactInList(true);
        } else {
          console.log(
            "userContactStatusName-> Error As Contact Status Not Found ",
            "Status Is :",
            contactStatus
          );
        }
      } catch (error) {
        console.log("userContactStatusName-> Error When Trying To Get Contact Status: ", error);
      }
    }
  };

  const setUpMemberListStatus = async () => {
    if (isSelfProfile === false) {
      setMemberListLoading(true);
      // Get contact status for each user and append to their data
      const res = await Getrequestcall(`${GET_USER_CONTACTS}/${userId}`, loginData?.accessToken);

      let otherUsers = res?.data?.data.filter(
        (user) => user.contactId !== loginData?.userInformation?.UserId
      );

      for (let i = 0; i < otherUsers?.length; i++) {
        try {
          const contactStatusRes = await Getrequestcall(
            `${GET_USER_CONTACT_STATUS_NAME}/${loginData?.userInformation?.UserId}/${otherUsers[i]?.contactId}`,
            loginData?.accessToken
          );

          const contactStatus = contactStatusRes?.data?.data;

          // Append contact status to the member object
          otherUsers[i].contactStatus = contactStatus;
        } catch (error) {
          console.log(
            "userContactStatusName-> Error When Trying To Get Contact Status for user:",
            otherUsers[i]?.id,
            error
          );
          // Set default contact status in case of error
          otherUsers[i].contactStatus = "No";
        }
      }

      // Set the users with appended contact status
      setMemberListLoading(false);
      setUserMemberList(otherUsers);
    }
  };

  async function handleAcceptContact() {
    try {
      const getObject = {
        Id: 0,
        UserId: Number(userId),
        ContactEmail: userData?.userEmail,
        EventStatusId: 2, // eventStatusId 5 = delete
        ModifiedBy: loginData?.userInformation?.UserId
      };
      await Postrequestcall(SAVECONTACTEVENT, getObject, loginData?.accessToken);
      // userContactStatusName(userId);

      const contacts = await Getrequestcall(
        `${GET_USER_CONTACTS}/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );

      let checkIsContactInList = contacts?.data?.data.some(
        (cont) => cont.contactId === Number(userId)
      );
      setIsContactInList(checkIsContactInList);
    } catch (error) {
      console.log("handleAcceptContact-> Error When Trying To Accept Connect Request: ", error);
    }
  }

  const handleAddContact = async (data, param) => {
    try {
      setShowBtnLoader(true);
      let obj = {
        UserId: Number(loginData?.userInformation?.UserId),
        FriendsEmails: data !== undefined ? data?.contactEmail : userData?.userEmail,
        Notification: {
          ActionUrl: `${import.meta.env.REACT_APP_CONTACTPROFILE}${Number(
            loginData?.userInformation?.UserId
          )}`,
          title: TEXT_CONNECT_REQUEST,
          Body: TEXT_REQUESTED_CONNECT_WITH_YOU
        }
      };
      const response = await Postrequestcall(INVITEFRIENDSBYEMAIL, obj, loginData?.accessToken);
      setShowBtnLoader(false);
      if (response?.data?.data === "Connect Request Send") {
        if (param === "Member-Modal") {
          setUpMemberListStatus();
          setMembersModalOpen(false);
        } else {
          setUpUserMemberListData();
        }
      }
    } catch (error) {
      console.log("handleAddContact-> Error When Trying To Add Contact: ", error);
      setShowBtnLoader(false);
    }
  };

  async function handleCancelRequest() {
    try {
      const getObject = {
        Id: 0,
        UserId: Number(loginData?.userInformation?.UserId),
        ContactEmail: userData?.userEmail,
        EventStatusId: 3, // eventStatusId 5 = delete
        ModifiedBy: loginData?.userInformation?.UserId
      };
      await Postrequestcall(SAVECONTACTEVENT, getObject, loginData?.accessToken);
      // userContactStatusName(userId);

      const contacts = await Getrequestcall(
        `${GET_USER_CONTACTS}/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );

      let checkIsContactInList = contacts?.data?.data.some(
        (cont) => cont.contactId === Number(userId)
      );
      setIsContactInList(checkIsContactInList);
      setUpUserMemberListData();
      setCancelConfirmModalOpen(false);
    } catch (error) {
      console.log("handleCancelRequest-> Error When Trying To Reject Connect Request: ", error);
    } finally {
      // setShowBtnLoader(false)
    }
  }

  async function handleDeleteContact() {
    try {
      const getObject = {
        Id: 0,
        UserId: Number(loginData?.userInformation?.UserId),
        ContactEmail: userData?.userEmail,
        EventStatusId: 5, // eventStatusId 5 = delete
        ModifiedBy: loginData?.userInformation?.UserId
      };
      await Postrequestcall(SAVECONTACTEVENT, getObject, loginData?.accessToken);
      // userContactStatusName(userId);
      setUpUserMemberListData();
      setDeleteConfirmModalOpen(false);
    } catch (error) {
      console.log("handleDeleteContact-> Error When Trying TO Delete Contact: ", error);
    }
  }

  // 6. Other event

  async function handleMemberListPressed() {
    setMembersModalOpen(true);
  }

  const handleEditProfile = () => {
    if (isSelfProfile) {
      setShowprofile(true);
    }
  };

  const navigateTochat = async (id) => {
    const targetUserId = id?.contactId || userId;
    createChatGroupAndNavigate(targetUserId, loginData, dispatch, navigate);
  };

  const handledata = async (data) => {
    if (data) {
      setVerifyPhoneObj([
        {
          verifyPhoneNo: data?.phoneNo,
          verifyPhoneId: data?.id,
          verifyCountryCode: data?.countryCode,
          UserPhoneId: data?.id
        }
      ]);
    }
    const smsObj = {
      userId: userId,
      phoneNo: Number(data.phoneNo) || verifyPhoneObj[0]?.verifyPhoneNo,
      countryCode: data.countryCode || verifyPhoneObj[0]?.verifyCountryCode
    };

    let getPhoneResponse = await Postrequestcall(
      SEND_SMS_TO_USER_PHONE,
      smsObj,
      loginData?.accessToken
    );
    if (getPhoneResponse?.status !== 200) {
      setSnackbarOpen(true);
    }
    return getPhoneResponse;
  };

  const handleTradeModal = (data) => {
    setEditFrom(data);
  };

  const handelVerifyModal = (item) => {
    let alertObj = {
      showAlert: true,
      text: item?.textTwo === "Primary" ? TEXT_EMAIL_NEED_TO_VERIFIED : TEXT_PHONE_NEED_TO_VERIFIED
    };
    dispatch(setShowalert(alertObj));
  };

  const isExpired = (expiryDate) => {
    if (expiryDate === "" || expiryDate === null) return;
    const currentDate = new Date();
    const expiry = new Date(expiryDate);
    return expiry < currentDate;
  };

  // 7. Return UI
  if (Initialisation) {
    return <Loader />;
  }

  // Header Section
  const HeaderSection = () => {
    const { multiLanguageData } = useSelector((state) => state?.main);
    const [displayedTradeCount, setDisplayedTradeCount] = useState(10);
    const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
    const [initialViewMore, setInitialViewMore] = useState(true);

    const {
      TEXT_PLEASE_ENTER_NAME = English?.Profile?.TEXT_PLEASE_ENTER_NAME,
      TEXT_DELETE_CONTACT = English?.Profile?.TEXT_DELETE_CONTACT,
      TEXT_JOINED = English?.Profile?.TEXT_JOINED,
      TEXT_VIEW_MORE = English?.Profile?.TEXT_VIEW_MORE,
      TEXT_VIEW_LESS = English?.Profile?.TEXT_VIEW_LESS,
      TEXT_CONNECT_SIMILAR_BID_USER = English?.Profile?.TEXT_CONNECT_SIMILAR_BID_USER,
      BUTTON_ADD_MY_TRADE = English?.Profile?.BUTTON_ADD_MY_TRADE,
      TEXT_MESSAGE = English?.Profile?.TEXT_MESSAGE,
      BUTTON_CONNECT = English?.Profile?.BUTTON_CONNECT,
      BUTTON_REQUESTED = English?.Profile?.BUTTON_REQUESTED,
      TEXT_ACCEPTCONTACT_BUTTON = English?.Profile?.TEXT_ACCEPTCONTACT_BUTTON,
      TEXT_BUILDER_NETWORK = English?.Profile?.TEXT_BUILDER_NETWORK,
      TEXT_REFER_SOMEONE_TO_BUILDID = English?.Profile?.TEXT_REFER_SOMEONE_TO_BUILDID
    } = multiLanguageData?.Profile || {};

    const handleReportTest = () => {
      setMoreMenuAnchorEl(false);
      setDeleteConfirmModalOpen(true);
    };

    const handleShowMoreTrades = () => {
      setInitialViewMore(false);
      setDisplayedTradeCount(userTrade.length);
    };

    const handleShowLessTrades = () => {
      setInitialViewMore(true);
      setDisplayedTradeCount(10);
    };

    const navigateToUsertickets = () => {
      try {
        navigate("/user-tickets/" + userId, {
          state: {
            status: ticketStatus,
            userInfo: userData
          }
        });
      } catch (error) {
        console.log("error");
      }
    };

    return (
      <>
        <Card className="pagelist-content" sx={{ p: 2 }}>
          <Grid container size={12}>
            <Grid size={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 2 }}>
              <Stack sx={{ alignItems: "center", justifyContent: "center" }} width={"100%"}>
                <Avatar
                  variant="circular"
                  src={userData?.pictureUrl}
                  onClick={() => setPictureViewerOpen(true)}
                  sx={{
                    height: {
                      xs: "100px",
                      sm: "130px",
                      md: "150px",
                      lg: "150px",
                      xl: "150px"
                    },
                    width: {
                      xs: "100px",
                      sm: "130px",
                      md: "150px",
                      lg: "150px",
                      xl: "150px"
                    }
                  }}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 9, sm: 9, md: 9, lg: 9, xl: 10 }} sx={{ pl: 2 }}>
              <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"}>
                {userData?.firstName || userData?.lastName ? (
                  <Stack direction={"row"} spacing={1}>
                    <Typography
                      
                      sx={{color: "primary",  fontWeight: "bold" }}
                      variant="h3"
                      maxWidth={"300px"}
                      noWrap>
                      {userData?.firstName}
                    </Typography>
                    <Typography
                      
                      sx={{color: "primary",  fontWeight: "bold" }}
                      variant="h3"
                      maxWidth={"300px"}
                      noWrap>
                      {userData?.lastName}
                    </Typography>
                  </Stack>
                ) : (
                  <Typography
                    variant="subtitle1"
                    style={{ cursor: "pointer", fontWeight: "bold" }}
                    onClick={handleEditProfile}>
                    {isSelfProfile ? TEXT_PLEASE_ENTER_NAME : "No User Name"}
                  </Typography>
                )}

                {!isSelfProfile ? (
                  <>
                    {contactStatusId === 1 && (
                      <div>
                        <IconButton onClick={(event) => setMoreMenuAnchorEl(event.currentTarget)}>
                          <MoreIcon />
                        </IconButton>
                        <Menu
                          anchorEl={moreMenuAnchorEl}
                          open={Boolean(moreMenuAnchorEl)}
                          onClose={() => setMoreMenuAnchorEl(false)}
                          anchorOrigin={{
                            horizontal: "right",
                            vertical: "bottom"
                          }}
                          transformOrigin={{
                            horizontal: "right",
                            vertical: "top"
                          }}>
                          <MenuItem
                            onClick={() => {
                              handleReportTest();
                            }}
                            style={{ color: BIRed }}
                            dense>
                            {TEXT_DELETE_CONTACT}
                          </MenuItem>
                        </Menu>
                      </div>
                    )}
                  </>
                ) : (
                  <IconButton color="primary" onClick={handleEditProfile}>
                    <EditIcon />
                  </IconButton>
                )}
              </Stack>
              {!isSelfProfile ? (
                <Typography variant="body2" sx={{ color: "grey" }}>
                  {" "}
                  {userData?.[0]?.value}
                </Typography>
              ) : null}
              {!isSelfProfile ? (
                <Typography variant="body2" sx={{ color: "grey" }}>
                  {/* {TEXT_JOINED} {userData?.[1]?.value} */}
                  {TEXT_JOINED} {moment(userData?.joinedBuildIdDate).format("LL")}{" "}
                </Typography>
              ) : null}
              {userTrade?.length > 0 ? (
                <Stack sx={{ justifyContent: "space-between", alignItems: "flex-start" }} direction={"row"}>
                  <Stack
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "7px",
                      alignItems: "center",
                      marginTop: "10px"
                    }}
                    direction="row"
                    spacing={0}>
                    {userTrade?.slice(0, displayedTradeCount)?.map((item, index) => {
                      return (
                        <Chip
                          size="small"
                          key={index.toString()}
                          className="chip-lable"
                          label={
                            item.tradeName.length > 30
                              ? item.tradeName?.trim()
                              : item.tradeName?.trim()
                          }
                          style={{
                            backgroundColor:
                              item?.tradeType?.toLowerCase() === "main" ? "#083DB8" : "null",
                            color: item?.tradeType?.toLowerCase() === "main" ? "white" : "null"
                          }}></Chip>
                      );
                    })}
                    {userTrade.length > 10 && (
                      <>
                        {initialViewMore ? (
                          <Button
                            style={{ borderRadius: "50px", color: "#083DB8" }}
                            size="small"
                            variant="text"
                            onClick={handleShowMoreTrades}>
                            {TEXT_VIEW_MORE} <KeyboardArrowDown fontSize="small" />
                          </Button>
                        ) : (
                          <Button
                            style={{ borderRadius: "50px", color: "#083DB8" }}
                            size="small"
                            variant="text"
                            onClick={handleShowLessTrades}>
                            {TEXT_VIEW_LESS} <KeyboardArrowUp fontSize="small" />
                          </Button>
                        )}
                      </>
                    )}
                  </Stack>
                  {isSelfProfile && (
                    <IconButton onClick={() => setShowInviteModal(true)}>
                      <QrCode sx={{ color: BIBlack }} fontSize="large" />
                    </IconButton>
                  )}
                </Stack>
              ) : (
                <>
                  {!isSelfProfile ? null : (
                    <Stack sx={{ justifyContent: "space-between", alignItems: "flex-start" }} direction={"row"}>
                      <Stack direction={"column"} sx={{ alignItems: "flex-start" }}>
                        <Typography sx={{ color: "gray" }}>{TEXT_CONNECT_SIMILAR_BID_USER} </Typography>
                        <Button
                          className="action-button"
                          onClick={() => {
                            setShowTrade(true);
                            handleTradeModal("profile");
                          }}
                          style={{ margin: "5px 0" }}>
                          {BUTTON_ADD_MY_TRADE}
                        </Button>
                      </Stack>
                      {isSelfProfile && (
                        <IconButton onClick={() => setShowInviteModal(true)}>
                          <QrCode sx={{ color: BIBlack }} fontSize="large" />
                        </IconButton>
                      )}
                    </Stack>
                  )}
                </>
              )}
              {!isSelfProfile ? (
                <>
                  <div style={{ marginTop: "10px" }}>
                    <Stack direction="row" spacing={1}>
                      {isContactInList ? (
                        <Button
                          color="primary"
                          variant="outlined"
                          onClick={() => {
                            navigateTochat();
                          }}>
                          {TEXT_MESSAGE}
                        </Button>
                      ) : miniLoader.profileLoader || contactStatusId === 1 ? null : (
                        <div>
                          {contactStatusId === 2 ? (
                            <>
                              <Stack direction="row" spacing={1}>
                                <Button
                                  color="primary"
                                  variant="contained"
                                  onClick={() => {
                                    handleAddContact();
                                  }}
                                  loading={showBtnLoader}
                                  disabled={showBtnLoader}>
                                  {BUTTON_CONNECT}
                                </Button>
                                <Button
                                  color="primary"
                                  variant="outlined"
                                  onClick={() => {
                                    navigateTochat();
                                  }}>
                                  {TEXT_MESSAGE}
                                </Button>
                              </Stack>
                            </>
                          ) : contactStatusId === 3 ? (
                            <Button
                              color="primary"
                              variant="outlined"
                              onClick={() => setCancelConfirmModalOpen(true)}>
                              {BUTTON_REQUESTED}
                            </Button>
                          ) : (
                            <Button
                              color="primary"
                              variant="contained"
                              loading={showBtnLoader}
                              disabled={showBtnLoader}
                              onClick={handleAcceptContact}>
                              {" "}
                              {TEXT_ACCEPTCONTACT_BUTTON}
                            </Button>
                          )}{" "}
                        </div>
                      )}

                      {ticketStatus === "Pending" || ticketStatus === "Accepted" ? (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() => navigateToUsertickets()}>
                          {"View tickets"}
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() => navigateToUsertickets()}>
                          {"Request for view tickets"}
                        </Button>
                      )}
                    </Stack>
                  </div>
                  {memberListLoading ? (
                    <Stack sx={{ mt: 1 }}>
                      <Skeleton variant="text" width={"20%"} height={24} />
                      <Stack direction={"row"} sx={{ gap: 1,  mt: 0.4  }} >
                        {[1, 2, 3, 4, 5].map(() => (
                          <Skeleton variant="circular" width={40} height={40} />
                        ))}
                      </Stack>
                    </Stack>
                  ) : userMemberList?.length === 0 ? null : (
                    <>
                      <div
                        className="flex-container-horizontal"
                        style={{
                          marginTop: "10px",
                          justifyContent: "space-between",
                          color: "gray"
                        }}>
                        <span style={{ fontSize: "14px" }}> {TEXT_BUILDER_NETWORK} </span>
                      </div>
                      <Stack
                        direction="row"
                        sx={{ justifyContent: "space-between" }}
                        style={{ padding: "10px 0px" }}>
                        {
                          <div style={{ display: "flex", flexDirection: "row" }}>
                            <Stack sx={{ marginRight: "10px", cursor: "pointer", alignItems: "center" }} direction="row" spacing={1} onClick={handleMemberListPressed}>
                              {userMemberList?.map((member, index) => (
                                <Avatar key={index} src={member.contactPictureUrl} />
                              ))}
                            </Stack>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <KeyboardArrowRightIcon
                                sx={{ color: "gray", cursor: "pointer" }}
                                onClick={handleMemberListPressed}
                              />
                            </div>
                          </div>
                        }
                      </Stack>
                    </>
                  )}
                </>
              ) : null}
            </Grid>
          </Grid>
        </Card>
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => setPictureViewerOpen(false)}
          src={userData?.pictureUrl}
        />
      </>
    );
  };

  // About Section
  const AboutSection = () => {
    const { multiLanguageData } = useSelector((state) => state?.main);

    const {
      TEXT_JOINED = English?.Profile?.TEXT_JOINED,
      TEXT_ABOUT = English?.Profile?.TEXT_ABOUT,
      BUTTON_EDIT = English?.Profile?.BUTTON_EDIT,
      BUTTON_ADD_MY_ADDRESS = English?.Profile?.BUTTON_ADD_MY_ADDRESS,
      TEXT_NO_MORE_INFORMATION = English?.Profile?.TEXT_NO_MORE_INFORMATION
    } = multiLanguageData?.Profile || {};
    return isSelfProfile ? (
      <>
        {userAboutData?.length !== 0 ? (
          <Card className="pagelist-content" style={{ padding: "15px" }}>
            <Stack direction="row" sx={{ justifyContent: "space-between" }}>
              <Typography variant="h6">{TEXT_ABOUT}</Typography>
              {!isSelfProfile ? null : (
                <Button
                  variant="contained"
                  sx={{ width: "fit-content", backgroundColor: BIBlue }}
                  className="active-btn"
                  onClick={() => setShowEditAbout(true)}>
                  {BUTTON_EDIT}
                </Button>
              )}
            </Stack>
            {userAboutData?.length !== 0 ? (
              <>
                {userAboutData?.map((item, index) =>
                  item?.address === false ? (
                    // Handle case where address is false (no address)
                    <React.Fragment key={index}>
                      <Stack sx={{ gap: 2,  margin: "12px 0px", alignItems: "flex-start"  }} direction="row" >
                        {item?.icon}
                        <Stack
                          width={"100%"}
                           sx={{ gap: 1, justifyContent: "space-between" }}
                          direction={"column"}>
                          <Stack>
                            <Typography variant="body1">{item?.textOne}</Typography>
                            <Typography variant="body2">{item?.textTwo}</Typography>
                          </Stack>
                          <Button variant="outlined" onClick={() => setShowEditAbout(true)}>
                            {BUTTON_ADD_MY_ADDRESS}
                          </Button>
                        </Stack>
                      </Stack>
                      <Divider />
                    </React.Fragment>
                  ) : (
                    // Handle emails, phones, and valid addresses
                    <React.Fragment key={index}>
                      {(item.isPublicEmail === true ||
                        item.isPublicPhone === true ||
                        item.verified === false ||
                        item.address) && (
                        <>
                          <Box sx={{ my: 1, mx: "auto" }}>
                            <Stack spacing={2} direction="row" sx={{ alignItems: "flex-start" }}>
                              <Icon> {item?.icon}</Icon>
                              <ListItemText
                                primary={
                                  <Typography
                                    variant="body1"
                                    noWrap={item?.address ? false : true}
                                    sx={{ color: !item?.verified ? "textSecondary" : "black" }}>
                                    {item?.textOne}
                                  </Typography>
                                }
                                secondary={item?.textTwo}
                              />
                              {!item?.verified && (
                                <IconButton onClick={() => handelVerifyModal(item)}>
                                  <InfoIcon fontSize="small" />
                                </IconButton>
                              )}
                            </Stack>
                          </Box>
                          <Divider />
                        </>
                      )}
                    </React.Fragment>
                  )
                )}
              </>
            ) : (
              <>{TEXT_NO_MORE_INFORMATION}</>
            )}
            {!isSelfProfile ? null : (
              <>
                <Stack direction="row"  sx={{ gap: 2, marginTop: "13px",  alignItems: "flex-start" }} >
                  <Typography variant="body1" sx={{ color: "grey" }}>
                    {TEXT_JOINED} {moment(userData?.joinedBuildIdDate).format("LL")}{" "}
                  </Typography>
                </Stack>
              </>
            )}
          </Card>
        ) : (
          <></>
        )}
      </>
    ) : (
      // For other users' profiles
      <>
        {userAboutData?.length !== 0 ? (
          <Card className="pagelist-content" style={{ padding: "15px" }}>
            <Stack direction="row" sx={{ justifyContent: "space-between" }}>
              <Typography variant="h6">{TEXT_ABOUT}</Typography>
            </Stack>
            {userAboutData?.length !== 0 ? (
              <>
                {userAboutData?.map((item, index) =>
                  item?.address === false ? (
                    <React.Fragment key={index}>
                      <Stack sx={{ gap: 2,  margin: "12px 0px", alignItems: "flex-start"  }} direction="row" >
                        {item?.icon}
                        <Stack sx={{ gap: 1 }} width={"100%"} >
                          <Typography variant="body1">{item?.textOne}</Typography>
                          <Typography variant="body2">{item?.textTwo}</Typography>
                        </Stack>
                      </Stack>
                      <Divider />
                    </React.Fragment>
                  ) : (
                    <React.Fragment key={index}>
                      <Box sx={{ my: 1, mx: "auto" }}>
                        <Stack spacing={2} direction="row" sx={{ alignItems: "flex-start" }}>
                          <Icon>
                            {index === 0 && String(item.textOne).includes("@") ? (
                              <Email sx={{ color: BIBlue }} />
                            ) : (
                              item?.icon
                            )}
                          </Icon>
                          <ListItemText
                            primary={
                              <Typography variant="body1" noWrap={item?.address ? false : true}>
                                {item?.textOne}
                              </Typography>
                            }
                            secondary={item?.textTwo}
                          />
                        </Stack>
                      </Box>
                      <Divider />
                    </React.Fragment>
                  )
                )}
              </>
            ) : (
              <>{TEXT_NO_MORE_INFORMATION}</>
            )}
          </Card>
        ) : (
          <></>
        )}
      </>
    );
  };

  const ContactCard = ({ contact, index }) => {
    return (
      <Card
        sx={{
          width: "120px",
          height: "170px",
          boxShadow: "none",
          borderRadius: 1,
          border: "1px solid lightgrey",
          marginTop: "0px"
        }}
        onClick={() => {
          navigate(`/${contact?.contactId}`);
        }}
        key={index}>
        <CardActionArea sx={{ marginTop: "0px" }}>
          <CardMedia
            component="img"
            height="100"
            image={contact?.contactPictureUrl}
            alt={`${contact?.firstName} ${contact?.lastName} Profile Picture`}
            sx={{ borderRadius: 1, objectFit: "cover" }}
            onError={(e) => (e.target.src = User_Default_Pic)}
          />
          <CardContent style={{ padding: "8px" }}>
            <Typography gutterBottom variant="body2" component="div">
              {contact?.contactName}
            </Typography>
            <Chip
              size="small"
              label={contact?.tradeName === "" ? `${TEXT_NO_MAIN_TRADE}` : contact?.tradeName}
            />
          </CardContent>
        </CardActionArea>
      </Card>
    );
  };

  const ContactCardSkeleton = ({ index }) => {
    return (
      <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }} key={`skeleton-${index}`}>
        <Card
          sx={{
            width: "100%",
            height: "200px",
            boxShadow: "none",
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            backgroundColor: "#fff",
            mb: 2
          }}>
          <CardActionArea sx={{ height: "100%" }}>
            <Skeleton
              variant="rectangular"
              height={120}
              sx={{
                borderRadius: "8px 8px 0 0",
                width: "100%"
              }}
            />
            <CardContent sx={{ padding: "8px" }}>
              <Skeleton
                variant="text"
                sx={{
                  fontSize: "0.875rem",
                  mb: 0.5,
                  width: "80%"
                }}
              />
              <Skeleton variant="rounded" width={80} height={20} />
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
    );
  };

  const TicketCardSkeleton = ({ index }) => {
    return (
      <Grid key={index} size={{ xs: 5.8, sm: 5.9, md: 5.9, lg: 3.8, xl: 2.9 }}>
        <Card className="pagelist-content">
          {/* Image Skeleton */}
          <Skeleton variant="rectangular" height={200} sx={{ cursor: "pointer" }} />

          <CardActions disableSpacing sx={{ flexDirection: "column", alignItems: "baseline" }}>
            <Stack direction="row" spacing={0.1} sx={{ justifyContent: "space-between" }} width={"100%"}>
              {/* Ticket Type Skeleton */}
              <Skeleton
                variant="text"
                sx={{
                  fontSize: "1rem",
                  maxWidth: { xs: "110px", md: "150px" }
                }}
                width="80%"
              />

              {/* Icons Stack Skeleton */}
              <Stack direction={"row"} sx={{ alignItems: "center" }}>
                <IconButton size="small" disabled>
                  <Skeleton variant="circular" width={20} height={20} />
                </IconButton>
                <IconButton size="small" disabled>
                  <Skeleton variant="circular" width={20} height={20} />
                </IconButton>
              </Stack>
            </Stack>

            {/* Issued By Skeleton */}
            <Skeleton
              variant="text"
              sx={{
                fontSize: "1rem",
                maxWidth: { xs: "200px", md: "250px" }
              }}
              width="70%"
            />
          </CardActions>
        </Card>
      </Grid>
    );
  };

  const TicketCard = ({ ticket, index }) => {
    return (
      <Grid key={ticket.id || index} size={{ xs: 5.8, sm: 5.9, md: 5.9, lg: 3.8, xl: 2.9 }}>
        <Card
          className="pagelist-content"
          sx={{ backgroundColor: isExpired(ticket.expiry) === true ? "#FABEBE" : "" }}>
          <CardMedia
            component="img"
            height="200"
            image={ticket?.frontPictureUrl}
            alt="Front Picture"
            sx={{ cursor: "pointer" }}
          />
          <CardActions disableSpacing sx={{ flexDirection: "column", alignItems: "baseline" }}>
            <Stack direction="row" spacing={0.1} sx={{ justifyContent: "space-between" }} width={"100%"}>
              <Typography variant="body1" sx={{ maxWidth: { xs: "110px", md: "150px" } }} noWrap>
                {ticket?.ticketType}
              </Typography>
              <Stack direction={"row"} sx={{ alignItems: "center" }}>
                {isExpired(ticket.expiry) === true && (
                  <IconButton color="secondary" size="small" aria-label="add to favorites">
                    <ErrorIcon fontSize="small" />
                  </IconButton>
                )}
                {ticket.sharedTicketsList?.length !== 0 && (
                  <IconButton color="default" size="small" aria-label="group">
                    <GroupIcon fontSize="small" />
                  </IconButton>
                )}
              </Stack>
            </Stack>
            <Typography variant="body1" sx={{ maxWidth: { xs: "200px", md: "250px" } }} noWrap>
              {ticket?.issuedBy}
            </Typography>
          </CardActions>
        </Card>
      </Grid>
    );
  };

  return (
    <>
      <Grid container size={12} spacing={1} sx={{ margin: 1 }}>
        {/* Header Section */}
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
          {miniLoader.profileLoader ? <ProfileHeaderSkeleton /> : <HeaderSection />}
        </Grid>
        {/* About Section */}
        {(contactStatusId === 1 || isSelfProfile) && userAboutData?.length > 0 && (
          <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
            {miniLoader.aboutLoader ? <AboutSekeleton /> : <AboutSection />}
            {isSelfProfile && (
              <>
                {miniLoader?.builderLoader ? (
                  <ContactCardSkeleton />
                ) : (
                  <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ mt: 1 }}>
                    <Card
                      className="pagelist-content"
                      style={{
                        padding: "8px",
                        display: "flex",
                        gap: "10px",
                        flexDirection: "column"
                      }}>
                      <Stack sx={{ justifyContent: "space-between", alignItems: "baseline" }} direction="row">
                        <Typography variant="body2">{TEXT_BUILDER_NETWORK}</Typography>
                        {!isSelfProfile ? null : contactData?.data?.length <= 0 ? null : (
                          <Button
                            variant="text"
                            sx={{ width: "fit-content", color: BIBlue, textTransform: "none" }}
                            className="active-btn"
                            onClick={() => setNewContactModalOpen(true)}
                            size="small">
                            {TEXT_LOOK_FOR_PEOPPLE}
                          </Button>
                        )}
                      </Stack>
                      {contactData?.data?.length >= 1 ? (
                        <Grid container size={12} spacing={1}>
                          {contactData?.data?.map((contact, index) => (
                            <Grid
                              size={{ xs: 4, sm: 4, md: 6, lg: 6, xl: 4 }}
                              key={contact?.id || index}>
                              <ContactCard contact={contact} index={`${contact?.id}/${index}`} />
                            </Grid>
                          ))}
                        </Grid>
                      ) : (
                        <Stack sx={{ mt: 1.5 }} textAlign={"center"} color={"grey"}>
                          {TEXT_NO_CONTACT_PLACEHOLDER}
                        </Stack>
                      )}
                      <Button
                        onClick={() => navigate("/contacts")}
                        variant={contactData?.data?.length >= 1 ? "contained" : "outlined"}
                        fullWidth
                        sx={{
                          textTransform: "none",
                          background: contactData?.data?.length >= 1 ? "lightgrey" : "",
                          color: contactData?.data?.length >= 1 ? "black" : BIBlue,
                          boxShadow: "none",
                          fontWeight: "light"
                        }}>
                        {contactData?.data?.length >= 1
                          ? `${TEXT_SEE_ALL} (${contactData?.nrOfRecords})`
                          : TEXT_LOOK_FOR_PEOPPLE}
                      </Button>
                      <Stack sx={{ mt: 1.5 }} textAlign={"end"}>
                        {isSelfProfile && (
                          <Typography
                            sx={{ color: "text.secondary" }}
                            variant="body2"
                            style={{ cursor: "pointer", color: BIBlue }}
                            onClick={() => setShowInviteModal(true)}>
                            {TEXT_REFER_SOMEONE_TO_BUILDID}
                          </Typography>
                        )}
                      </Stack>
                    </Card>
                  </Grid>
                )}
              </>
            )}
          </Grid>
        )}

        {(contactStatusId === 1 || isSelfProfile) && (
          <Grid
            // container
            size={{
              xs: 12,
              sm: 12,
              md: contactStatusId === 1 && userAboutData?.length > 0 ? 8 : isSelfProfile ? 8 : "",
              lg: contactStatusId === 1 && userAboutData?.length > 0 ? 8 : isSelfProfile ? 8 : "",
              xl: contactStatusId === 1 && userAboutData?.length > 0 ? 8 : isSelfProfile ? 8 : ""
            }}>
            <Stack sx={{ gap: 1 }} >
              {isSelfProfile === false && (
                <Grid container size={{ xs: 12 }} sx={{ gap: 1 }}>
                  {ticketLoading
                    ? [1, 2, 3, 4]?.map((index) => <TicketCardSkeleton index={index} />)
                    : userTicketData?.map((ticket, index) => (
                        <TicketCard ticket={ticket} index={index} />
                      ))}
                </Grid>
              )}
              <Grid id="experience-section" size={{ xs: 12 }}>
                <Experience
                  profileSectionLoadingState={miniLoader}
                  setProfileSectionLoadingState={setMiniLoader}
                />
              </Grid>
              <Grid id="education-section" size={{ xs: 12 }}>
                <Education
                  profileSectionLoadingState={miniLoader}
                  setProfileSectionLoadingState={setMiniLoader}
                />
              </Grid>
              <Grid size={{ xs: 12 }} maxHeight={"45vh"}>
                <Products
                  profileSectionLoadingState={miniLoader}
                  setProfileSectionLoadingState={setMiniLoader}
                />
              </Grid>
            </Stack>
          </Grid>
        )}
      </Grid>

      {showEditAbout && (
        <Editabout
          showAbout={showEditAbout}
          handleClose={() => {
            setShowEditAbout(false);
          }}
          getInformationData={() => {
            fetchUserData(1);
          }}
          setVerifyEmailModalOpen={setVerifyEmailModalOpen}
          setVerifyPhoneModalOpen={setVerifyPhoneModalOpen}
          handledata={handledata}
          setAboutDataLoading={setMiniLoader}
          setEditedTab={setEditedTab}
        />
      )}

      {showProfile && (
        <Editprofile
          showProfile={showProfile}
          handleClose={() => {
            setShowprofile(false);
            setEditFrom("");
            setCloseTradeFrom(false);
          }}
          getUserInfo={() => {
            fetchUserData();
          }}
          setShowTrade={setShowTrade}
          trades={userTrade}
          setUsertrades={setUserTrade}
          handleTradeModal={handleTradeModal}
          closeTradeFrom={closeTradeFrom}
          setEditedTab={setEditedTab}
          resetTradeLoading={(fn) => setResetTradeLoadingFn(() => fn)}
        />
      )}

      {showTrade && (
        <EditTrade
          showTrade={showTrade}
          handleClose={() => {
            setShowTrade(false);
            if (editFrom === "edit profile") {
              // Reset trade loading when closing without saving
              if (resetTradeLoadingFn) resetTradeLoadingFn();
              setCloseTradeFrom(true);
            }
          }}
          userTradeList={userTrade}
          onDataSave={() => {
            setShowTrade(false);
            if (editFrom === "edit profile") {
              // Reset trade loading when saving
              if (resetTradeLoadingFn) resetTradeLoadingFn();
              setCloseTradeFrom(true);
            }
            fetchUserTradeData();
          }}
        />
      )}

      {showInviteModal && (
        <ReferralModal
          open={showInviteModal}
          from={"home"}
          TEXT_MASSAGE={TEXT_MASSAGE}
          TEXT_COPY_LINK={TEXT_COPY_LINK}
          onClose={() => {
            setShowInviteModal(false);
          }}
        />
      )}

      {verifyEmailModalOpen && (
        <VerifyEmailModal
          onOpen={verifyEmailModalOpen}
          onClose={() => {
            setVerifyEmailModalOpen(false);
            setShowEditAbout(true);
          }}
        />
      )}

      {verifyPhoneModalOpen && (
        <VerifyPhoneModal
          onOpen={verifyPhoneModalOpen}
          onClose={() => {
            setVerifyPhoneModalOpen(false);
            setShowEditAbout(true);
          }}
          handledata={handledata}
          verifyPhoneObj={verifyPhoneObj}
        />
      )}

      {membersModalOpen && (
        <MemberList
          isOpen={membersModalOpen}
          onClose={() => setMembersModalOpen(false)}
          members={userMemberList}
          profileMemberList={true}
          handleConnectClick={handleAddContact}
          handleMessageClick={navigateTochat}
          showBtnLoader={showBtnLoader}
          from={"profile"}
        />
      )}
      {cancelConfirmModalOpen && (
        <PromptModal
          isOpen={cancelConfirmModalOpen}
          onClose={() => setCancelConfirmModalOpen(false)}
          title={TEXT_CANCEL_REQUEST}
          desc={TEXT_ALERT_CANCEL_REQUEST}
          redButtonText={BUTTON_MODAL_DELETE_YES}
          onRedButtonClick={() => {
            handleCancelRequest();
          }}
        />
      )}

      {deleteConfirmModalOpen && (
        <PromptModal
          isOpen={deleteConfirmModalOpen}
          onClose={() => setDeleteConfirmModalOpen(false)}
          title={TEXT_DELETE_CONTACT_CONF_TITLE}
          desc={TEXT_DESC_CONFIRMATION}
          redButtonText={BUTTON_DELETE}
          onRedButtonClick={() => handleDeleteContact()}
        />
      )}

      <Snackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={"Something Went Wrong While Sending OTP"}
        autoHideDuration={3000}
      />
      {newContactModalOpen && (
        <AddContact
          isOpen={newContactModalOpen}
          onClose={() => {
            if (shouldCall === true) {
              getUserContact();
              setMiniLoader({
                ...miniLoader,
                builderLoader: true
              });
            }
            setNewContactModalOpen(false);
          }}
          setNewContactModalOpen={setNewContactModalOpen}
          from={"Profile"}
          setShouldCall={setShouldCall}
        />
      )}
    </>
  );
}

